module.exports = __webpack_public_path__ + "img/hangzhourongzi.12851090.png";